<template>
  <div>
    <a-col :span="24">
      <div v-if="loading" class="mt-2">
        <center>
          <a-spin/>
        </center>
      </div>
      <div class="pr-2" v-else>
        <div>
          <a-modal
            ref="modal"
            :title="'Assign Permissions to User'"
            :footer="null"
            class="permission-modal"
            v-model="visible"
            @cancel="onCancel"
            okText="Create"
          >
            <a-row class="pt-2 pr-2">
              <a-form :form="form" @submit="assignRole">
                <a-col :span="24">
                  <h5 class="text-opacity">Name of User</h5>
                  <h4>{{user.first_name}} {{user.last_name}}</h4>
                </a-col>
                <a-col :span="24" class="mt-2">
                  <a-col :span="24">
                    <a-form-item>
                      <h4
                        class="text-opacity"
                      >Permissions (Select permissions to be assigned to {{user.last_name}})</h4>
                      <a-input
                        @change="filterPermissions"
                        v-model="searchFields"
                        class="custom-input"
                        placeholder="🔍 Quickly Search for Permissions"
                      ></a-input>
                      <div>
                        <small class="text-opacity" style="float:left">
                          <b style="transform:rotate(90deg)">+</b>
                          {{this.form.getFieldsValue() && this.form.getFieldsValue().permissions && this.form.getFieldsValue().permissions.length > 0 ? this.form.getFieldsValue().permissions.length : 0}} Roles Selected
                        </small>
                        <small class="text-opacity" style="float:right">
                          <b style="transform:rotate(90deg)">></b> Scroll down for more
                        </small>
                      </div>
                    </a-form-item>
                    <a-form-item>
                      <a-checkbox-group
                        v-decorator="['permissions', {initialValue: userPermissions}]"
                        style="width: 100%;"
                      >
                        <a-row v-if="permissions.length > 0" class="role-checkbox-wrapper">
                          <a-col
                            v-for="(permission,index) in permissions"
                            :key="index"
                            :span="24"
                            class="role-checkbox"
                          >
                            <a-checkbox
                              style="width:100%"
                              :value="permission.id"
                            >{{permission.name.split("-").join(" ")}}</a-checkbox>
                          </a-col>
                        </a-row>

                        <a-row v-else>
                          <a-col :span="24">
                            <center>No Available Data for Permissions.</center>
                          </a-col>
                        </a-row>
                      </a-checkbox-group>
                    </a-form-item>
                  </a-col>
                </a-col>
                <a-col :span="24">
                  <div class="ant-modal-footer" style="padding-right:0">
                    <div>
                      <button @click="onCancel" type="button" class="ant-btn">
                        <span>Cancel</span>
                      </button>
                      <button type="submit" class="ant-btn ant-btn-primary">
                        <span>Assign Permission</span>
                      </button>
                    </div>
                  </div>
                </a-col>
              </a-form>
            </a-row>
          </a-modal>
        </div>
        <!-- <permission-form :permission="permission"></permission-form> -->
      </div>
    </a-col>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      user: {},
      visible: true,
      searchFields: "",
      selectedRoles: "",
      roles: [],
      role: {},
      permissions: [],
      userPermissions: [],
      form: this.$form.createForm(this, { name: "coordinated" })
    };
  },
  computed: {
    userRoles() {
      return this.user && this.user.roles ? this.user.roles.map(s => s.id) : [];
    }
  },
  methods: {
    fetchUser() {
      this.$store
        .dispatch("getUser", this.$route.params.id)
        .then(s => {
          this.loading = false;
          this.user = s.data;
          this.fetchUserPermissions();
        })
        .catch(() => {
          this.$message.error("Record for your request was not found!");
        });
    },
    fetchUserPermissions() {
      this.$store
        .dispatch("getUserPermissions", this.$route.params.id)
        .then(s => {
          this.userPermissions = s.data.map(s => s.id);
        });
    },
    fetchPermissions() {
      this.$store.dispatch("getPermissions").then(s => {
        this.permissions = s;
      });
    },
    filterPermissions() {
      if (this.searchFields !== "") {
        let filteredPermissions = this.$store.getters.permissions.filter(s => {
          return s.name.match(new RegExp(this.searchFields, "ig"));
        });
        if (filteredPermissions.length > 0) {
          this.permissions = filteredPermissions;
        } else {
          //make request to the api
          let searchParams = this.searchFields;
          this.fetchPermissionsWithParams(searchParams);
        }
      } else {
        this.fetchPermissions();
      }
    },
    fetchPermissionsWithParams(params) {
      this.$store.dispatch("getPermissions", `search=${params}`).then(s => {
        this.permissions = s;
      });
    },
    assignRole(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const hide = this.$message.loading("Assigning Roles to User");
          let data = {
            user_id: this.user.id,
            permissions: values.permissions
          };
          this.$store
            .dispatch("assignPermissionToUsers", data)
            .then(() => {
              setTimeout(hide, 20);
              this.$message.success(
                "🔏 Permission Successfully assigned to User"
              );
            })
            .catch(err => {
              //error message is't consistent from backend
              let errors =
                err.data && err.data.message && err.data.message.errors;
              if (err.status === 422 || err.status === 400) {
                setTimeout(hide, 20);
                Object.values(errors).forEach(s => {
                  this.$message.error("Sorry, " + s, 2.5);
                });
              }
            });
        }
      });
    },
    onCancel() {
      return this.$router.go(-1);
    }
  },
  mounted() {
    this.fetchUser();
    this.fetchPermissions();
  }
};
</script>
